import { environment } from 'environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// register syncfusion api key here
registerLicense(environment.syncFusionLicense);

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
